import React from "react";

const HorizontalMenu = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M5.2 15c1.767 0 3.2 1.393 3.2 3.111 0 1.718-1.433 3.111-3.2 3.111-1.767 0-3.2-1.393-3.2-3.11C2 16.391 3.433 15 5.2 15zM18 15c1.767 0 3.2 1.393 3.2 3.111 0 1.718-1.433 3.111-3.2 3.111-1.767 0-3.2-1.393-3.2-3.11C14.8 16.391 16.233 15 18 15zM30.8 15c1.767 0 3.2 1.393 3.2 3.111 0 1.718-1.433 3.111-3.2 3.111-1.767 0-3.2-1.393-3.2-3.11 0-1.72 1.433-3.112 3.2-3.112z"
          fill={fill}
      />
    </svg>
);

export default HorizontalMenu;
